import Layout from "@/components/Layout/Layout"
import { PlayerStatsLookup } from "@/components/admin/PlayerStatsLookup"
import { useAuthContext } from "@/contexts/AuthContext"
import NotFound from "./NotFound"
import { LoadingScreen } from "@/components/ui/loading-spinner"
import { Navigate, useLocation, useParams } from "react-router-dom"

export function AdminPlayerStats() {
  const { isAuthenticated, isAdmin, loading } = useAuthContext()
  const { playerCode } = useParams()
  const { pathname } = useLocation()

  if (loading) {
    return <LoadingScreen message="Cargando estadisticas de jugador..." />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isAdmin) {
    return <NotFound />
  }

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Stats de Jugador</h1>
          <p className="text-lg text-muted-foreground mt-2">
            Busca por codigo de jugador para revisar sus estadisticas competitivas.
          </p>
        </div>

        <PlayerStatsLookup key={pathname} initialPlayerCode={playerCode} />
      </div>
    </Layout>
  )
}
